module.exports = __webpack_public_path__ + "static/media/attendee.ab1c6d72.png";